module.exports = __webpack_public_path__ + "media/images/site1-c47a2c00cf0023dc0e532c3a2378d199.png";